export default "__VITE_ASSET__COG2n3r2__"